import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from '../../../../../styles/widgets/feature-fit-v2/last-updated-answers.module.scss';

// TODO: Discuss with Volo whether we need this component.
const LastUpdatedAnswers = React.memo(({ label = 'Answers last updated:', formattedDate, className }) => {
  return (
    <div className={classnames(styles.container, className)}>
      <p className={styles.label}>
        {label}&nbsp;<b>{formattedDate}</b>
      </p>
    </div>
  );
});

LastUpdatedAnswers.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  formattedDate: PropTypes.string.isRequired
};

LastUpdatedAnswers.displayName = 'LastUpdatedAnswers';

export default LastUpdatedAnswers;
